import { Button, Card, CardContent, CardHeader, CardTitle } from '@crm/ui';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { signOut } from '../../../api/auth.ts';
import { useSessionQuery } from '../../../api/session.ts';
import { Planned } from '../../../components/placeholders.tsx';
import { FeatureBoundary, RouteErrorPanel } from '../../../components/route-error-boundary.tsx';
import {
  HermesMemoriesPanel,
  HermesPersonaPanel,
  LlmSpendPanel,
} from '../../../components/settings/hermes-section.tsx';

export const Route = createFileRoute('/_authed/settings/profile')({
  component: ProfileSettings,
  errorComponent: RouteErrorPanel,
});

function ProfileSettings() {
  const session = useSessionQuery();
  const navigate = useNavigate();

  return (
    <div className="flex max-w-xl flex-col gap-4">
      <Card>
        <CardHeader>
          <CardTitle>You</CardTitle>
        </CardHeader>
        <CardContent className="flex flex-col gap-2 text-sm">
          <div className="grid grid-cols-[7rem_1fr] gap-y-1">
            <span className="text-muted-foreground">Name</span>
            <span>{session.data?.name ?? '—'}</span>
            <span className="text-muted-foreground">Email</span>
            <span>{session.data?.email ?? '—'}</span>
            <span className="text-muted-foreground">Active org</span>
            <span className="font-mono text-xs">{session.data?.activeOrgId ?? 'none'}</span>
          </div>
          <Button
            variant="outline"
            size="sm"
            className="mt-3 w-fit"
            onClick={() => {
              void signOut().then(() => navigate({ to: '/login' }));
            }}
          >
            Sign out
          </Button>
        </CardContent>
      </Card>

      <Planned
        title="Editing your name and email"
        description="Changing the name and address on your account will live here. Nothing else on this page depends on it — the digest already writes in your voice, and you can shape that under “How Hermes writes” below."
      />

      {/*
        Hermes lives on the profile page rather than behind its own route: it is
        about the PERSON, not the workspace, and the three panels below are the
        only surfaces where §2.2's "visibility is mandatory" and §1.8's cache-hit
        ratio are visible at all.

        Each is boundaried on its own — a spend ledger that fails to load must
        not take the memory list (and its Undo buttons) with it.
      */}
      <FeatureBoundary feature="the Hermes persona">
        <HermesPersonaPanel />
      </FeatureBoundary>
      <FeatureBoundary feature="learned memories">
        <HermesMemoriesPanel />
      </FeatureBoundary>
      <FeatureBoundary feature="AI spend">
        <LlmSpendPanel />
      </FeatureBoundary>
    </div>
  );
}
